import { render, staticRenderFns } from "./ActivitiesOptions.vue?vue&type=template&id=135adeae&scoped=true&"
import script from "./ActivitiesOptions.vue?vue&type=script&lang=js&"
export * from "./ActivitiesOptions.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesOptions.vue?vue&type=style&index=0&id=135adeae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135adeae",
  null
  
)

export default component.exports